<template>
    <div style="height: 100%;">
        <MagazzinoArticoliGiacenzeListComponent v-show="isOperazioneCaricoMagazzino"
            ref="cmpMagazzinoArticoliGiacenzeListComponent" @onRowSelectedArticoliItems="onRowSelectedArticoliItems"
            @onSelectedLottoMatricola="onRowSelectedLottoMatricola" @onAddLottoMatricola="onAddLottoMatricola"
            @updateRowNumberGiacenza="onUpdateRowNumberGiacenza" />
        <MagazzinoArticoliGiacenzaCodiciComponent v-show="isOperazioneScaricoMagazzino"
            ref="cmpMagazzinoArticoliListComponent" @updateRowNumberGiacenza="onUpdateRowNumberGiacenza"
            @onRowSelectedArticoliItems="onRowSelectedArticoliItems" :selectable="true" :component="true"
            :tableHideColumn="['actions']" :pagination="false" />


    </div>

</template>

<script>
import MagazzinoArticoliGiacenzeListComponent from './MagazzinoArticoliGiacenzeListComponent.vue';
import MagazzinoArticoliGiacenzaCodiciComponent from './MagazzinoArticoliGiacenzaCodiciComponent.vue';
import ContabilitaMixin from '../../contabilita/mixins/ContabilitaMixin';
export default {
    mixins: [ContabilitaMixin],
    components: { MagazzinoArticoliGiacenzeListComponent, MagazzinoArticoliGiacenzaCodiciComponent },
    props: {
        isEdit: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            jsonData: {},
            localData: {},
            rigaDocumento: {},
            customFilter: {},
            filtroMatricolaLotto: {},
            selectedItem: []
        }
    },
    computed: {
        isOperazioneCaricoMagazzino() {
            return this.jsonData.causaleDocumentoOperazioneMagazzino == 1;
        },
        isOperazioneScaricoMagazzino() {
            return this.jsonData.causaleDocumentoOperazioneMagazzino == -1;
        }
    },
    methods: {
        init(documentoJson, customFilter, riga) {
            this.jsonData = documentoJson;
            this.customFilter = customFilter;
            this.rigaDocumento = riga;
            this.loadData();
        },
        setRigaDocumento(riga) {
            if (this.$refs.cmpMagazzinoArticoliGiacenzeListComponent) {

                this.$refs.cmpMagazzinoArticoliGiacenzeListComponent.setRigaDocumento(riga);
            }
        },
        loadData() {
            if (this.isOperazioneCaricoMagazzino) {
                delete this.customFilter.lottoMatricola
                this.$refs.cmpMagazzinoArticoliGiacenzeListComponent.setFiltroRigaDocumentoOperazione(this.customFilter, this.rigaDocumento, this.jsonData.causaleDocumentoOperazioneMagazzino);

            } else {
                let filtro = {
                    codiceStruttura: this.jsonData.strutturaCodice,
                    page: this.customFilter.page,
                    forPage: this.customFilter.forPage,
                    nomeArticolo: this.rigaDocumento.descrizione,
                    lottoMatricola: this.customFilter.lottoMatricola
                }
                this.$refs.cmpMagazzinoArticoliListComponent.loadDataArticoli(filtro)
            }

        },

        onRowSelectedArticoliItems(item) {
            this.selectedItem = item;
            this.emitSelectedItem(item)
        },

        emitSelectedItem(item) {
            this.$emit("onRowSelectedArticoliItems", item)
        },
        onRowSelectedLottoMatricola(item) {
            //TODO DA RIVEDERE PERCHè ADESSO NON SI SELEZIONA PIU LOTTO MATRICOLA MA DIRETTAMENTE SU RECORD
            this.$emit("onSelectedLottoMatricola", item)
        },


        onUpdateRowNumberGiacenza(num) {
            this.$emit("updateRowNumberGiacenza", num)
        },
        onAddLottoMatricola(item) {
            this.$emit("onAddLottoMatricola", item)
        }
    }

}
</script>

<style lang="scss" scoped></style>